import { useQuery } from "@tanstack/react-query";

import type {
    IndustryTaxonomyDto,
    IndustryTaxonomyIndex,
} from "app/pages/sales-intelligence/domain/industry/types/taxonomy";
import { indexTaxonomy } from "app/pages/sales-intelligence/domain/industry/utils/taxonomy";

import { createTaxonomyQuery } from "./options";

type UseIndustryTaxonomyQueryOptions = {
    enabled?: boolean;
};

/**
 * Module-level so the reference is stable: react-query only reuses a memoized `select` result when
 * both `data` and `options.select` are reference-stable. An inline arrow would silently re-index the
 * whole taxonomy on every render of the filters-config hook.
 */
const select = (dto: IndustryTaxonomyDto): IndustryTaxonomyIndex => indexTaxonomy(dto);

export default function useIndustryTaxonomyQuery({ enabled = true }: UseIndustryTaxonomyQueryOptions = {}) {
    return useQuery(createTaxonomyQuery({ select, enabled }));
}
